<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="!isMB">
        <el-button size="small" class="filter-item" @click="onExport" type="primary" plain>导出</el-button>
      </template>
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/consume/banklog/list";

export default {
  name: "turnover",
  mixins: [curdMixins],
  components: {
    list,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
    }
  },
  methods: {
    onExport() {
      this.$refs.list.export();
    },
  },
};
</script>